import { debounce } from 'vue-debounce';
import parsePhoneNumber from 'libphonenumber-js';

import {
  REGEX_WHITESPACES, REGEX_NUMBERS, REGEX_NOT_PHONE_NUMBER, REGEX_VALID_EMAIL,
} from '@/constants/constants';

import CountrySelector from './CountrySelector/index.vue';
import countriesFlags from './CountrySelector/countriesFlags';


const EIGHT_CODES = ['48', '886', '82', '850', '853', '856', '81', '852', '86', '855', '880'];


export default {
  name: 'MultiloginInput',

  props: {
    value: String,
    title: String,
    required: Boolean,
    type: String,
    placeholder: String,
    placeholderMobile: String,
    icon: String,
    disabled: Boolean,
  },

  components: {
    CountrySelector,
  },

  watch: {
    login() {
      this.$emit('input', this.login.replace(/\s/g, ''));
    },
  },

  methods: {
    onChangeInput() {
      if (!this.login) {
        return;
      }

      let number = this.login.replace(REGEX_WHITESPACES, '').match(REGEX_NUMBERS);
      number = number ? number[0] : '';

      this.$emit('onChange', this.login);

      if (!this.login.match(REGEX_NOT_PHONE_NUMBER) && number.charAt(0) === '8') {
        if (number.length > 2) {
          if (
            !EIGHT_CODES.includes(number.substring(0, 2))
            && !EIGHT_CODES.includes(number.substring(0, 3))
          ) {
            number = `7${number.substring(1)}`;
            this.isEigtTransfered = true;
          }
        }
      }

      const parsedNumber = parsePhoneNumber(`+${number}`);

      this.countryCode = '';
      this.operatorCode = '';
      this.subscriberNumber = '';
      this.inputSplit = false;
      this.isInputDisabled = false;
      this.isError = false;
      this.isPhoneNumberValid = false;

      if (this.login.match(REGEX_NOT_PHONE_NUMBER)) {
        if (this.isEigtTransfered) {
          if (this.login.charAt(0) === '+') {
            this.login = `8${this.login.substring(2)}`;
          } else {
            this.login = `8${this.login.substring(1)}`;
          }

          this.isEigtTransfered = false;
        }

        debounce(() => { this.$refs.multilogin.focus(); }, 1)();
        return;
      }

      if (parsedNumber && this.type !== 'email') {
        this.isPhoneNumberValid = true;
        const splitedNumber = parsedNumber.formatInternational().split(' ');

        [this.countryCode, this.operatorCode] = splitedNumber;
        splitedNumber.splice(0, 2);
        this.subscriberNumber = splitedNumber.join(' ');

        if (this.subscriberNumber) {
          this.login = parsedNumber.formatInternational();
          this.isInputDisabled = true;
          debounce(() => { this.inputSplit = true; }, 300)();
          debounce(() => { this.$refs.splitLogin.focus(); }, 310)();
        }

        if (parsedNumber.country) {
          this.setFlag(parsedNumber.country);
        }
      }

      if (!this.inputSplit) {
        debounce(() => { this.$refs.multilogin.focus(); }, 200)();
      }
    },

    onChangeSplitedInput() {
      this.base64CountryFlag = '';
      this.buildLogin();

      if (!this.operatorCode || !this.subscriberNumber) {
        this.onChangeInput();
        return;
      }

      if (this.login.match(REGEX_NOT_PHONE_NUMBER)) {
        this.onChangeInput();
        return;
      }

      const parsedNumber = parsePhoneNumber(this.login);

      if (parsedNumber) {
        if (parsedNumber.country) {
          this.setFlag(parsedNumber.country);
        }
      }
    },

    updateCountryCode(data) {
      this.isEigtTransfered = false;
      this.countryCode = `+${data.code}`;
      this.buildLogin();
      this.setFlag(data.alpha2);
    },

    buildLogin() {
      this.login = (this.countryCode
        + this.operatorCode
        + this.subscriberNumber
      ).replace(/\s/g, '');

      this.$emit('onChange', this.login);
    },

    setFlag(alpha2Code) {
      this.base64CountryFlag = `data:image/png;base64,${countriesFlags[alpha2Code.toLowerCase()]}`;
    },

    getType() {
      if (this.isPhoneNumberValid) {
        return 'phone';
      }

      if (this.login.match(REGEX_VALID_EMAIL)) {
        return 'email';
      }

      return null;
    },

    validate() {
      if (this.login) {
        if (this.type) {
          if (this.type === 'both') {
            const verifyResults = [
              this.isPhoneNumberValid,
              Boolean(this.login.match(REGEX_VALID_EMAIL)),
            ];

            if (!verifyResults.includes(true)) {
              this.isError = true;
            }
          } else {
            if (!this.isPhoneNumberValid && (this.type === 'phone')) {
              this.isError = true;
            }

            if (this.login.match(REGEX_NOT_PHONE_NUMBER) || (this.type === 'email')) {
              if (!this.login.match(REGEX_VALID_EMAIL)) {
                this.isError = true;
              }
            }
          }
        }
      } else {
        if (!this.required) {
          return true;
        }
        this.isError = true;
      }

      return !this.isError;
    },
  },

  created() {
    this.onChangeInput();
    this.isInputDisabled = this.disabled;
  },

  data() {
    return {
      login: this.login || this.value,
      inputSplit: this.inputSplit,
      countryCode: this.countryCode,
      operatorCode: this.operatorCode,
      subscriberNumber: this.subscriberNumber,
      base64CountryFlag: this.base64CountryFlag,
      isInputDisabled: this.isInputDisabled,
      isError: this.isError,
    };
  },
};
